export enum NumericOperator {
    GREATER_THAN = 'gt',
    LESS_THAN = 'lt',
    EQUAL_TO = 'eq',
}
